/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type MenuBarLinkProps = {
  route: string;
  children: React.ReactNode;
};

export function MenuBarLink({ route, children }: MenuBarLinkProps) {
  const { pathname } = useLocation();
  const isSelected = pathname.startsWith(route);
  return (
    <StyledLink
      to={route}
      className={isSelected ? "selected" : undefined}
      data-cy={`menu-button-${route.substring(1)}`}
    >
      {children}
    </StyledLink>
  );
}

const StyledLink = styled(Link)`
  color: ${theme.color.text.text01};
  text-decoration: none;
  width: 100%;

  &:hover,
  &:active,
  &.selected {
    border-radius: ${theme.radius.md};
    color: ${theme.color.text.text01};
    text-decoration: none;
  }

  &:hover {
    background-color: ${theme.color.interactive.secondary};
  }

  &:active {
    background-color: ${theme.color.interactive.secondaryActive};
  }

  &.selected {
    background-color: ${theme.color.interactive.secondaryHover};
  }
`;
